import { Box } from "@mui/material";
import React from "react";
import SocialMedia from "./SocialMedia";
import Home from "./Home";
import LoginPage from "./LoginPage";
import RegisterPage from "./RegisterPage";

const Bodi = (propse) => {
  const onClick = (e) => {
    propse.setExtra(true);
    propse.setRegister(false);
    propse.setLogin(false);
    propse.setMoreInfo(true);
  };
  return (
    <React.Fragment>
      <Box
        sx={{
          width: "100%",
          height: propse.Width < 560 ? "100%" : "calc(100% - 120px)",
        }}
      >
        <Box
          sx={{
            marginTop: "30px",
            marginLeft: "30px",
            display: propse.Width < 560 ? "flex" : "none",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{ width: "40px", height: "6px", backgroundColor: "#ed013e" }}
          ></Box>
          <Box
            sx={{
              width: "150px",
              height: "20px",
              fontFamily: "Aboreto",
              fontSize: "0.6rem",
              fontWeight: "bold",
              color: "rgba(0,0,0,0.8)",
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              justifyContent: "center",
              marginTop: "3px",
            }}
          >
            you know about
          </Box>
          <Box
            sx={{
              width: "180px",
              height: "25px",
              fontFamily: "Poppins",
              fontSize: "1.4rem",
              fontWeight: "bold",
              color: "rgba(0,0,0,0.7)",
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              justifyContent: "center",
            }}
          >
            LEITNER BOX
          </Box>
          <Box
            sx={{
              width: "150px",
              height: "20px",
              fontFamily: "Aboreto",
              fontSize: "0.6rem",
              fontWeight: "bold",
              color: "rgba(0,0,0,0.8)",
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              justifyContent: "center",
              marginTop: "0px",
              cursor: "pointer",
            }}
          >
            <span className="AUL" onClick={onClick}>
              show more &#8702;
            </span>
          </Box>
          <Box
            sx={{
              width: "95%",
              display: "flex",
              flexDirection: "column",
              fontFamily: "Outfit",
              fontSize: "0.7rem",
              color: "rgba(0,0,0,0.6)",
              marginTop: "20px",
            }}
          >
            <span>Copyright © December-2021. </span>
            <span>All rights Reserved.</span>
            <span>Created by Ramin Maghsoodi</span>
            <SocialMedia />
          </Box>
        </Box>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: propse.Width < 560 ? "none" : "flex",
            flexDirection: "row",
          }}
        >
          <Box
            sx={{
              width: "8px",
              height: "100%",
              backgroundColor: "#ffc300",
            }}
          ></Box>
          <Box
            sx={{
              width: "60%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              // backgroundColor: "rgba(255,155,55,0.2)",
            }}
          >
            <Box
              sx={{
                width: "calc(100% - 70px)",
                height: "calc(100% - 50px)",
                marginTop: "25px",
                marginLeft:
                  propse.Width >= 560 && propse.Width < 768 ? "25px" : "50px",
                // backgroundColor: "rgba(255,155,55,0.2)",
                overflowY: "auto",
              }}
            >
              {propse.Login ? (
                <LoginPage
                  Width={propse.Width}
                  Height={propse.Height}
                  setRegister={propse.setRegister}
                  setLogin={propse.setLogin}
                  setShowModal={propse.setShowModal}
                  Loading={propse.Loading}
                  setLoading={propse.setLoading}
                  setEmailRepeat={propse.setEmailRepeat}
                  setisLogged={propse.setisLogged}
                />
              ) : propse.Register ? (
                <RegisterPage
                  Width={propse.Width}
                  Height={propse.Height}
                  HTMLFor="R-B"
                  setRegister={propse.setRegister}
                  setLogin={propse.setLogin}
                  setShowModal={propse.setShowModal}
                  Loading={propse.Loading}
                  setLoading={propse.setLoading}
                  setEmailRepeat={propse.setEmailRepeat}
                />
              ) : (
                <Home Width={propse.Width} Height={propse.Height} />
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default Bodi;
